import { styled } from '@linaria/react';
import Image from 'next/image';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(LocalizedFormat);
import { Avatar, TextLink } from '@vidbaseapp/styleguide';
import { StyledLandingSection } from './LandingSection';
export const StyledMediaCard = /*#__PURE__*/styled("div")({
  name: "StyledMediaCard",
  class: "smv5a35"
});
const PRODUCTION_LINKS = {
  'Vidbase Creators': 'https://vid.bs/creators/yt',
  'Fund BMC': 'https://vid.bs/fundbmc/yt'
};
const PRODUCTIONS_RELEASES = [{
  type: 'Video Essay',
  href: '#',
  slug: 'succession-tig',
  account: 'Vidbase Creators',
  creator: 'Nancy Xu',
  date: '2022-03-01T17:00:00.000Z',
  avatar: 'https://cdn.vidbase.app/img/vidbase-creators-avatar.png',
  thumbnail: 'https://cdn.vidbase.app/episodes/succession-the-impossible-game-thumbnail.png',
  headline: 'Succession - The Impossible Game',
  body: `This video essay dissects the game of Succession: is it really possible for Roman,
		Shiv, or Kendall to win? The ending of season three shows that the race to become
		the next CEO is in fact a scheme through which Logan Roy controls and wields power
		over his children — one designed so that only he can win, again, and again. In
		this video, we dive deeper into why that is, and also explore the show's subtext
		surrounding the cyclical nature of abuse.`
}, {
  type: 'Interview',
  slug: 'fundbmc-s2e3',
  href: 'https://youtu.be/jVeckkjE2K0',
  account: 'Fund BMC',
  creator: 'Hong Quan',
  date: '2020-05-20T17:00:00.000Z',
  avatar: 'https://cdn.vidbase.app/img/fundbmc-avatar.png',
  thumbnail: 'https://fundbmc.com/episodes/episode-010-thumbnail.jpg',
  headline: 'Fund BMC S02E03: Jonathan Basker',
  body: `Hong (@quan) and Jonathan (@basker) have a chat about finding a job during downturns and how to prepare yourself for the best outcome. Topics include: job hunting during COVID-19 (2:00), Hong's first job, how to get into tech/startups without a technical background, how to know if your resume isn't working, what a day in the life of a startup recruiter looks like, the best tool to help you look credible, an important tactical way to stand out with your resume, and why (if you can) skip the resume entirely.`
}, {
  type: 'Interview',
  slug: 'fundbmc-s2e2',
  href: 'https://www.youtube.com/watch?v=pXY0ae27_ts',
  account: 'Fund BMC',
  creator: 'Hong Quan',
  date: '2020-05-05T17:00:00.000Z',
  avatar: 'https://cdn.vidbase.app/img/fundbmc-avatar.png',
  thumbnail: 'https://fundbmc.com/episodes/episode-009-thumbnail.jpg',
  headline: 'Fund BMC S02E02: Arlan Hamilton',
  body: `Hong (@quan) and Arlan (@arlanwashere) have a chat about the wild ride of investing in underrepresented groups. Topics include: how to invest in the underrepresented, how venture capital works, her first million podcast, almost being on reality TV, whether Asian Americans are considered underrepresented, and her new book "It's About Damn Time".`
}];
export const LandingProductions = () => {
  return <StyledLandingSection className="productions dotted" bg={'var(--clr-nav-shadow)'}>
			<div className="content">
				<div className="headline">
					<h2>Productions</h2>
					<p>From tutorials to original content, enjoy the show!</p>
				</div>
				<StyledMediaCard className="media-cards">
					{PRODUCTIONS_RELEASES.map((episode, i) => {
          return <div className="media-card-container" key={`episode-${i}`}>
								<div className="media-card">
									<a href={episode.href}>
										<Image src={episode.thumbnail} alt={`${episode.headline} | ${episode.account}`} width="312" height="175.5" />
									</a>
									<div className="card-body" id={episode.slug}>
										<h3>{episode.type}</h3>
										<a href={episode.href}>
											<h1>{episode.headline}</h1>
										</a>
										<input type="checkbox" id={`${episode.slug}-expanded`} />
										<p className="clamped">{episode.body}</p>
										<TextLink as="label" className="more" htmlFor={`${episode.slug}-expanded`} role="button">
											Show more.
										</TextLink>
										<TextLink as="label" className="less" htmlFor={`${episode.slug}-expanded`} role="button">
											Show less.
										</TextLink>
									</div>
									<div className="media-creator">
										<a href={PRODUCTION_LINKS[episode.account] || ''}>
											<Avatar src={episode.avatar} alt={episode.account} initials={'VB'} />
										</a>
										<div className="media-creator-meta">
											<a href={PRODUCTION_LINKS[episode.account] || ''}>
												<h2>{episode.account}</h2>
											</a>
											<p>
												{dayjs(episode.date).format('ll')} · {episode.creator}
											</p>
										</div>
									</div>
								</div>
							</div>;
        })}
				</StyledMediaCard>
			</div>
		</StyledLandingSection>;
};

require("./LandingProductions.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingProductions.tsx");